import nav from "./components/nav_es.json";
import movement_table from "./components/movement_table_es.json";
import staging_timeline from "./components/staging_timeline_es.json";
import bolton from "./components/bolton_es.json";
import overjet_overbite from "./components/overjet_overbite_es.json";
import controls from "./components/controls_es.json";
import others from "./components/others_es.json";
export const es = {
  nav: { ...nav },
  movement_table: { ...movement_table },
  staging_timeline: { ...staging_timeline },
  bolton: { ...bolton },
  overjet_overbite: { ...overjet_overbite },
  controls: { ...controls },
  other: { ...others },
};
